import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IntroduceSection5Image10 from '../../assets/introduce_section5_image10.png';
import IntroduceSection5Image2 from '../../assets/introduce_section5_image2.png';
import IntroduceSection5Image7 from '../../assets/introduce_section5_image7.svg';
import IntroduceSection5Image8 from '../../assets/introduce_section5_image8.png';
import IntroduceSection5Image9 from '../../assets/introduce_section5_image9.png';
import NextButton from '../../assets/next_button.svg';
import { CenterLayout, HorizontalEqualLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H2, TitleNormal, TitleNormalBold } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import { ClickableImage } from '../common/ClickableImage';

const IntroduceSection5 = () => {
  const { t } = useTranslation();
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile, screenWidth } = useDeviceType();
  const [index, setIndex] = useState(0);
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{ background: 'white', paddingLeft: padding, paddingRight: padding, overflow: 'hidden', }}>
      <BTBox height={isMobile ? 60 : `${pxToRem(238)}`} />
      <H2>Client Reviews</H2>
      <BTBox height={isMobile ? 16 : `${pxToRem(59)}`} />
      <VerticalLayout wrapContents={true} >
        {!isMobile && (
          <HorizontalLayout backgroundColor='#FAFAFA' wrapContents={true}>
            <img src={index == 0 ? IntroduceSection5Image8 : index == 1 ? IntroduceSection5Image9 : IntroduceSection5Image10} style={{ width: `${pxToRem(504)}`, height: `${pxToRem(531)}` }} />
            <VerticalLayout wrapContents={true} paddingTop={`${pxToRem(69)}`} style={{ marginLeft: pxToRem(82) }}>
              <div style={{
                marginRight: `${pxToRem(39)}`,
                ...isChina ? { wordBreak: 'break-all' } : { wordBreak: 'keep-all' }
              }}><TitleNormal fontSize={isMobile ? '16px' : `${pxToRem(28)}`} color='black' style={{
                lineHeight: `${pxToRem(49)}`, minHeight: `${pxToRem(49 * 6)}`,
                ...isChina ? { wordBreak: 'break-all' } : {}
              }}>{index === 0 ? t('반도체 라인 초정밀 공정에 필수적인 극저온 배관 설계 및 시공을 우수한 품질로 수행해 주었어요. 특히 자체 개발한 극저온 배관 기술은 경쟁사 대비 차별화되있으며, 효율적인 시공 일정관리로 조기가동에 기여해주고 있습니다. 향후에도 높은 전문성과 기술력을 발전시켜 나가는 비비테크의 모습을 기대합니다.') : index === 1 ? t('반도체 FAB의 설계부터 시공, 운영에 이르기까지 전 과정에서 체계적이고 신속한 대응을 통해 Etcher Demo FAB 구축 프로젝트를 안정적으로 완료하였습니다. 실무 협업 과정에서도 전문성과 유연성을 고루 갖춘 신뢰할 수 있는 파트너입니다. 오랜 기간 상호 신뢰를 바탕으로 한 동반 성장이 이어지길 기대합니다.') : t('비비테크는 평택 캠퍼스 주요 라인에서 고난이도 설비 시공을 안정적으로 수행해왔습니다. 특히, 자동화 및 소프트웨어 기반의 기술 역량을 지속적으로 강화하며 발주처의 기술적 요구에 선제적으로 대응하고 있는 점이 인상 깊었습니다. 앞으로도 지속적인 발전을 기대하며, 언제나 응원하겠습니다.')}</TitleNormal></div>
              <BTBox height={`${pxToRem(31)}`} />
              <HorizontalLayout paddingRight={`${pxToRem(33)}`} style={{ alignItems: 'end' }}>
                <VerticalLayout>
                  <TitleNormalBold fontSize={isMobile ? '14px' : `${pxToRem(28)}`} color='black'>{index === 0 || index === 2 ? t('삼성전자') : t('히타치하이테크코리아')}</TitleNormalBold>
                  <BTBox height={10} />
                  <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{index === 0 ? t('화성 H3 프로젝트팀') : index === 1 ? 'Smart Fab' : t('평택 FT시공 그룹')}</TitleNormal>
                </VerticalLayout>
                <img src={index === 0 || index === 2 ? IntroduceSection5Image2 : IntroduceSection5Image7} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
              </HorizontalLayout>
            </VerticalLayout>
            <CenterLayout width={120} height={`${pxToRem(531)}`} style={{ paddingRight: `${pxToRem(40)}` }}>
              <ClickableImage src={NextButton} onClick={() => {
                var temp = index + 1;
                if (temp > 2) {
                  temp = 0;
                }
                setIndex(temp);
              }} data-analytics-name="클라이언트리뷰_다음" />
            </CenterLayout>
          </HorizontalLayout>
        )}

        {isMobile && (
          screenWidth > 880 ? (
            <HorizontalEqualLayout gap={pxToRem(24)}>
              <VerticalLayout backgroundColor='#FAFAFA' wrapContents={true} style={{ paddingBottom: '25px' }} >
                <img src={IntroduceSection5Image8} style={{ width: '100%' }} />
                <BTBox height={21} />
                <VerticalLayout wrapContents={true} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div style={{ wordBreak: 'keep-all' }}><TitleNormal fontSize={isMobile ? '16px' : `${pxToRem(32)}`} color='black' style={{
                    lineHeight: isMobile ? '24px' : `${pxToRem(52)}`, minHeight: isMobile ? `${24 * 10}px` : `${pxToRem(52 * 6)}`,
                    ...isChina ? { wordBreak: 'break-all' } : {}
                  }}>{t('반도체 라인 초정밀 공정에 필수적인 극저온 배관 설계 및 시공을 우수한 품질로 수행해 주었어요. 특히 자체 개발한 극저온 배관 기술은 경쟁사 대비 차별화되있으며, 효율적인 시공 일정관리로 조기가동에 기여해주고 있습니다. 향후에도 높은 전문성과 기술력을 발전시켜 나가는 비비테크의 모습을 기대합니다.')}</TitleNormal></div>
                  <BTBox height={`${pxToRem(31)}`} />
                  <HorizontalLayout paddingRight={0} style={{ alignItems: 'end' }}>
                    <VerticalLayout>
                      <TitleNormalBold fontSize={isMobile ? '14px' : `${pxToRem(28)}`} color='black'>{t('삼성전자')}</TitleNormalBold>
                      <BTBox height={10} />
                      <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{t('화성 H3 프로젝트팀')}</TitleNormal>
                    </VerticalLayout>
                    <img src={IntroduceSection5Image2} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </VerticalLayout>

              <VerticalLayout backgroundColor='#FAFAFA' wrapContents={true} style={{ paddingBottom: '25px' }} >
                <img src={IntroduceSection5Image9} style={{ width: '100%' }} />
                <BTBox height={21} />
                <VerticalLayout wrapContents={true} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div style={{ wordBreak: 'keep-all' }}><TitleNormal fontSize={isMobile ? '16px' : `${pxToRem(33)}`} color='black' style={{
                    lineHeight: isMobile ? '24px' : `${pxToRem(52)}`, minHeight: isMobile ? `${24 * 10}px` : `${pxToRem(52 * 6)}`,
                    ...isChina ? { wordBreak: 'break-all' } : {}
                  }}>{t('반도체 FAB의 설계부터 시공, 운영에 이르기까지 전 과정에서 체계적이고 신속한 대응을 통해 Etcher Demo FAB 구축 프로젝트를 안정적으로 완료하였습니다. 실무 협업 과정에서도 전문성과 유연성을 고루 갖춘 신뢰할 수 있는 파트너입니다. 오랜 기간 상호 신뢰를 바탕으로 한 동반 성장이 이어지길 기대합니다.')}</TitleNormal></div>
                  <BTBox height={`${pxToRem(31)}`} />
                  <HorizontalLayout paddingRight={0} style={{ alignItems: 'end' }}>
                    <VerticalLayout>
                      <TitleNormalBold fontSize={isMobile ? '14px' : `${pxToRem(28)}`} color='black'>{t('히타치하이테크코리아')}</TitleNormalBold>
                      <BTBox height={10} />
                      <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{'Smart Fab'}</TitleNormal>
                    </VerticalLayout>
                    <img src={IntroduceSection5Image7} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </VerticalLayout>

              <VerticalLayout backgroundColor='#FAFAFA' wrapContents={true} style={{ paddingBottom: '25px' }} >
                <img src={IntroduceSection5Image10} style={{ width: '100%' }} />
                <BTBox height={21} />
                <VerticalLayout wrapContents={true} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div style={{ wordBreak: 'keep-all' }}><TitleNormal fontSize={isMobile ? '16px' : `${pxToRem(33)}`} color='black' style={{
                    lineHeight: isMobile ? '24px' : `${pxToRem(52)}`, minHeight: isMobile ? `${24 * 10}px` : `${pxToRem(52 * 6)}`,
                    ...isChina ? { wordBreak: 'break-all' } : {}
                  }}>{t('비비테크는 평택 캠퍼스 주요 라인에서 고난이도 설비 시공을 안정적으로 수행해왔습니다. 특히, 자동화 및 소프트웨어 기반의 기술 역량을 지속적으로 강화하며 발주처의 기술적 요구에 선제적으로 대응하고 있는 점이 인상 깊었습니다. 앞으로도 지속적인 발전을 기대하며, 언제나 응원하겠습니다.')}</TitleNormal></div>
                  <BTBox height={`${pxToRem(31)}`} />
                  <HorizontalLayout paddingRight={0} style={{ alignItems: 'end' }}>
                    <VerticalLayout>
                      <TitleNormalBold fontSize={isMobile ? '14px' : `${pxToRem(28)}`} color='black'>{t('삼성전자')}</TitleNormalBold>
                      <BTBox height={10} />
                      <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{t('평택 FT시공 그룹')}</TitleNormal>
                    </VerticalLayout>
                    <img src={IntroduceSection5Image2} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </VerticalLayout>
            </HorizontalEqualLayout>
          ) : (
            <HorizontalLayout style={{ overflow: 'auto' }}>
              <VerticalLayout width={271} backgroundColor='#FAFAFA' wrapContents={true} style={{ paddingBottom: '25px', marginRight: '16px' }} >
                <img src={IntroduceSection5Image8} style={{ width: '271px', height: '259px' }} />
                <BTBox height={21} />
                <VerticalLayout wrapContents={true} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div style={{ wordBreak: 'keep-all' }}><TitleNormal fontSize={isMobile ? isEng ? '11px' : '16px' : `${pxToRem(32)}`} color='black' style={{
                    lineHeight: isMobile ? isEng ? '16px' : '24px' : `${pxToRem(52)}`, minHeight: isMobile ? isEng ? `${16 * 12}px` : isChina ? `${24 * 8}px` : `${24 * 11}px` : `${pxToRem(52 * 6)}`,
                    ...isChina ? { wordBreak: 'break-all' } : {}
                  }}>{t('반도체 라인 초정밀 공정에 필수적인 극저온 배관 설계 및 시공을 우수한 품질로 수행해 주었어요. 특히 자체 개발한 극저온 배관 기술은 경쟁사 대비 차별화되있으며, 효율적인 시공 일정관리로 조기가동에 기여해주고 있습니다. 향후에도 높은 전문성과 기술력을 발전시켜 나가는 비비테크의 모습을 기대합니다.')}</TitleNormal></div>
                  <BTBox height={`${pxToRem(31)}`} />
                  <HorizontalLayout paddingRight={0} style={{ alignItems: 'end' }}>
                    <VerticalLayout>
                      <TitleNormalBold fontSize={isMobile ? isEng ? '10px' : '14px' : `${pxToRem(28)}`} color='black'>{t('삼성전자')}</TitleNormalBold>
                      <BTBox height={10} />
                      <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{t('화성 H3 프로젝트팀')}</TitleNormal>
                    </VerticalLayout>
                    <img src={IntroduceSection5Image2} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </VerticalLayout>

              <VerticalLayout width={271} backgroundColor='#FAFAFA' wrapContents={true} style={{ paddingBottom: '25px', marginRight: '16px' }} >
                <img src={IntroduceSection5Image9} style={{ width: '271px', height: '259px' }} />
                <BTBox height={21} />
                <VerticalLayout wrapContents={true} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div style={{ wordBreak: 'keep-all' }}><TitleNormal fontSize={isMobile ? isEng ? '11px' : '16px' : `${pxToRem(33)}`} color='black' style={{
                    lineHeight: isMobile ? isEng ? '16px' : '24px' : `${pxToRem(52)}`, minHeight: isMobile ? isEng ? `${16 * 12}px` : isChina ? `${24 * 8}px` : `${24 * 11}px` : `${pxToRem(52 * 6)}`,
                    ...isChina ? { wordBreak: 'break-all' } : {}
                  }}>{t('반도체 FAB의 설계부터 시공, 운영에 이르기까지 전 과정에서 체계적이고 신속한 대응을 통해 Etcher Demo FAB 구축 프로젝트를 안정적으로 완료하였습니다. 실무 협업 과정에서도 전문성과 유연성을 고루 갖춘 신뢰할 수 있는 파트너입니다. 오랜 기간 상호 신뢰를 바탕으로 한 동반 성장이 이어지길 기대합니다.')}</TitleNormal></div>
                  <BTBox height={`${pxToRem(31)}`} />
                  <HorizontalLayout paddingRight={0} style={{ alignItems: 'end' }}>
                    <VerticalLayout>
                      <TitleNormalBold fontSize={isMobile ? isEng ? '10px' : '14px' : `${pxToRem(28)}`} color='black'>{t('히타치하이테크코리아')}</TitleNormalBold>
                      <BTBox height={10} />
                      <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{'Smart Fab'}</TitleNormal>
                    </VerticalLayout>
                    <img src={IntroduceSection5Image7} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </VerticalLayout>

              <VerticalLayout width={271} backgroundColor='#FAFAFA' wrapContents={true} style={{ paddingBottom: '25px' }} >
                <img src={IntroduceSection5Image10} style={{ width: '271px', height: '259px' }} />
                <BTBox height={21} />
                <VerticalLayout wrapContents={true} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div style={{ wordBreak: 'keep-all' }}><TitleNormal fontSize={isMobile ? isEng ? '11px' : '16px' : `${pxToRem(33)}`} color='black' style={{
                    lineHeight: isMobile ? isEng ? '16px' : '24px' : `${pxToRem(52)}`, minHeight: isMobile ? isEng ? `${16 * 12}px` : isChina ? `${24 * 8}px` : `${24 * 11}px` : `${pxToRem(52 * 6)}`,
                    ...isChina ? { wordBreak: 'break-all' } : {}
                  }}>{t('비비테크는 평택 캠퍼스 주요 라인에서 고난이도 설비 시공을 안정적으로 수행해왔습니다. 특히, 자동화 및 소프트웨어 기반의 기술 역량을 지속적으로 강화하며 발주처의 기술적 요구에 선제적으로 대응하고 있는 점이 인상 깊었습니다. 앞으로도 지속적인 발전을 기대하며, 언제나 응원하겠습니다.')}</TitleNormal></div>
                  <BTBox height={`${pxToRem(31)}`} />
                  <HorizontalLayout paddingRight={0} style={{ alignItems: 'end' }}>
                    <VerticalLayout>
                      <TitleNormalBold fontSize={isMobile ? isEng ? '10px' : '14px' : `${pxToRem(28)}`} color='black'>{t('삼성전자')}</TitleNormalBold>
                      <BTBox height={10} />
                      <TitleNormal fontSize={isMobile ? '10px' : `${pxToRem(22)}`} color='#979797'>{t('평택 FT시공 그룹')}</TitleNormal>
                    </VerticalLayout>
                    <img src={IntroduceSection5Image2} style={{ width: `${pxToRem(120)}`, height: `${pxToRem(40)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </VerticalLayout>
            </HorizontalLayout>
          )
        )}
      </VerticalLayout>
    </VerticalLayout>
  );
};

export default IntroduceSection5;
